'use client';

import { usePathname } from 'next/navigation';
import { useDispatch } from 'react-redux';

import { cx } from '@/shared/lib/cx';
import { Icon } from '@/shared/ui/icon';
import { IconButton, IconLink } from '@/shared/ui/icon-button';

import { authPanelActions } from '../model/auth-panel-slice';
import styles from './account-button.module.scss';

/** Header account icon: guests open the sign-in panel, customers go to the account. */
export function AccountButton({ authenticated }: { authenticated: boolean }) {
  const dispatch = useDispatch();
  const pathname = usePathname();
  const current = pathname.startsWith('/account');
  if (authenticated) {
    return (
      <IconLink
        href="/account"
        label="Личный кабинет"
        aria-current={current ? 'page' : undefined}
        className={cx(current && styles.current)}
      >
        <Icon name="user" />
      </IconLink>
    );
  }
  return (
    <IconButton
      label="Личный кабинет"
      aria-haspopup="dialog"
      onClick={() => dispatch(authPanelActions.opened(null))}
    >
      <Icon name="user" />
    </IconButton>
  );
}
